import { FC, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaIcon } from '../../common/FaIcon';
import {
  TypeCardDescription,
  TypeCardIconWrap,
  TypeCardRoot,
  TypeCardTitle,
} from './AnalyticsTypeCardStyles';

interface Props {
  icon: IconProp;
  titleKey: string;
  descriptionKey: string;
  onClick?: () => void;
}

export const AnalyticsTypeCard: FC<Props> = ({ icon, titleKey, descriptionKey, onClick }) => {
  const { t } = useTranslation();

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (onClick && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <TypeCardRoot
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <TypeCardIconWrap>
        <FaIcon icon={icon} width={26} height={26} />
      </TypeCardIconWrap>
      <TypeCardTitle>{t(titleKey)}</TypeCardTitle>
      <TypeCardDescription>{t(descriptionKey)}</TypeCardDescription>
    </TypeCardRoot>
  );
};
